import { useState, type FC, type ReactNode } from 'react';
import { useRpmActivity } from 'infrastructure/hooks/rpm';
import useUser from 'utils/useUser';
import classNames from 'classnames';
import { Divider } from 'antd';

import s from './styles.module.scss';
import { PAGE_SIZE } from '../../constants';

import type { IRpmPatientActivity } from 'infrastructure/interfaces/i-rpm-patient-activity';

type RenderFnProps = {
  page: number;
  setPage: (n: number) => void;
  activity: IRpmPatientActivity | undefined;
  loading: boolean;
};
type RenderFn = (pops: RenderFnProps) => ReactNode;

interface ExpandContainerProps {
  patientGuid: string;
  average: ReactNode;
  table: RenderFn;
  info: ReactNode;
  endTime: number;
  startTime: number;
}

const ExpandContainer: FC<ExpandContainerProps> = ({
  patientGuid,
  average,
  table,
  info,
  endTime,
  startTime,
}) => {
  const [page, setPage] = useState(1);
  const { isCriticalOrAtRiskAlertingRole, isMedicalAssistantRole } = useUser();
  const { activity, isLoading, isFetching } = useRpmActivity(
    {
      reviewed: false,
      patientGuid,
      applySpecialFilter: isCriticalOrAtRiskAlertingRole === true,
      startTime,
      endTime,
      skipMACheck: isMedicalAssistantRole || undefined,
      page,
      applyLinkedCalls: true,
      reverse: true,
    },
    PAGE_SIZE,
  );

  return (
    <div
      className={classNames(s.wrapper, {
        [s['one-row']]: isCriticalOrAtRiskAlertingRole,
      })}
      data-expanded-content="true"
    >
      <div className={s.average}>{average}</div>
      <Divider className={s.splitter} />
      <div className={s['table-info-wrapper']}>
        <div className={s.table}>
          {table({ page, setPage, activity, loading: isFetching || isLoading })}
        </div>
        <div className={s.info}>{info}</div>
      </div>
    </div>
  );
};
export default ExpandContainer;
